<div *ngIf="!loaded" style="height: 10px"></div>
<div *ngIf="loaded">
    <iui-messages #messages class="ms-auto me-auto"> </iui-messages>
</div>
<h2 class="mb-5">Edit Billing Information for Short Code {{ scId }}</h2>

<ng-template [ngIf]="scId && model">
    <h5>Billing Information</h5>
    <div class="my-3">
        <app-address-book (addressChosen)="loadApplicantAddress($event)"></app-address-book>
    </div>
    <div class="row my-4">
        <div class="col-md-3">
            <strong>Order ID:</strong>
            {{ model.orderId }}
        </div>
        <div class="col-md-8" tooltipPosition="top" appShowToolTipIfTruncated>
            <strong>Short Codes in Order:</strong>
            {{ model.scList }}
        </div>
    </div>
    <form id="application-form" (keydown.enter)="handleEnter($event)" class="presubmit" #application="ngForm"
        (ngSubmit)="next(application)">
        <div class="row my-4">
            <div class="col-md-5">
                <label for="appFirstName" class="required">First Name</label>
                <input appScrText placeholder="First Name" appFirstNameValidator required
                    maxlength="{{ MaxLen.FirstName }}" id="appFirstName" name="appFirstName" #appFirstName="ngModel"
                    autocomplete="billing given-name" [(ngModel)]="model.billingFirstName" />
                <app-error-msg [field]="appFirstName" fieldLabel="First Name"></app-error-msg>
            </div>
            <div class="col-md-5">
                <label for="appLastName" class="required">Last Name</label>
                <input appScrText placeholder="Last Name" appLastNameValidator required
                    autocomplete="billing family-name"
                    maxlength="{{ MaxLen.LastName }}" id="appLastName" name="appLastName" #appLastName="ngModel"
                    [(ngModel)]="model.billingLastName" />
                <app-error-msg [field]="appLastName" fieldLabel="Last Name"></app-error-msg>
            </div>
        </div>
        <div class="row my-4">
            <div class="col-md-3">
                <label for="appPhoneInput" class="required">Phone Number</label>
                <app-phone [(ngModel)]="model.billingPhone" #appPhone="ngModel" class="col-12" required name="appPhone"
                    autocomplete="billing tel" id="appPhone"></app-phone>
                <app-error-msg [field]="appPhone" fieldLabel="Phone Number"></app-error-msg>
            </div>
            <div class="col-md-2">
                <label for="appExt">Extension</label>
                <input appScrText [(ngModel)]="model.billingPhoneExtension" id="appExt" name="appExt"
                    autocomplete="billing tel-extension" maxlength="{{ MaxLen.PhoneExtension }}" />
            </div>
            <div class="col-md-5">
                <label for="appEmail" class="required">Email</label>
                <input appScrText placeholder="Email" required appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" maxlength="{{ MaxLen.Email }}"
                    autocomplete="billing email"
                    id="appEmail" name="appEmail" #appEmail="ngModel" [(ngModel)]="model.billingEmail" />
                <app-error-msg [field]="appEmail" fieldLabel="Email"></app-error-msg>
            </div>
        </div>
        <div class="row my-4">
            <div class="col-md-4">
                <label for="appCountry" class="required">Country</label>
                <app-country-dropdown id="appCountry" [(ngModel)]="model.billingCountry" name="appCountry"
                    autocomplete="billing country"
                    #appCountry="ngModel"></app-country-dropdown>
                <app-error-msg [field]="appCountry" fieldLabel="Country"></app-error-msg>
            </div>
        </div>
        <div class="row my-4">
            <div class="col-12">
                <label for="appAddress1" class="required">Street Address 1</label>
                <input appScrText placeholder="Street Address 1" required maxlength="{{ MaxLen.Address }}"
                    autocomplete="billing address-line1"
                    id="appAddress1" name="appAddress1" #appAddress1="ngModel" [(ngModel)]="model.billingAddress1" />
                <app-error-msg [field]="appAddress1" fieldLabel="Address"></app-error-msg>
            </div>
        </div>
        <div class="row my-4">
            <div class="col-12">
                <label for="appAddress2">Street Address 2</label>
                <input appScrText placeholder="Street Address 2" maxlength="{{ MaxLen.Address }}" id="appAddress2"
                autocomplete="billing address-line2"
                name="appAddress2" #appAddress2="ngModel" [(ngModel)]="model.billingAddress2" />
            </div>
        </div>
        <div class="row my-4">
            <div class="col-md-4">
                <label for="appCity" class="required">City</label>
                <input appScrText placeholder="City" required maxlength="{{ MaxLen.City }}" id="appCity" name="appCity"
                    autocomplete="billing address-level2"
                    #appCity="ngModel" [(ngModel)]="model.billingCity" />
                <app-error-msg [field]="appCity" fieldLabel="City"></app-error-msg>
            </div>
            <div class="col-md-4">
                <label for="appRegionInput" [ngClass]="{ required: getRegionRequired() }">State/Province</label>
                <app-region-dropdown [(ngModel)]="model.billingState" [country]="model.billingCountry" name="appRegion"
                    autocomplete="billing address-level1"
                    #appRegion="ngModel" id="appRegion"></app-region-dropdown>
                <app-error-msg [field]="appRegion" fieldLabel="State/Province"></app-error-msg>
            </div>
            <div class="col-md-4">
                <label for="appZipInput" [ngClass]="{ required: getRegionRequired() }">Zip/Postal Code</label>
                <app-zipcode-input [(ngModel)]="model.billingZip" [country]="model.billingCountry" name="appZip"
                    autocomplete="billing postal-code"
                    #appZip="ngModel" id="appZip" inputId="appZipInput" placeholder="Zip/Postal Code"></app-zipcode-input>
                <app-error-msg [field]="appZip" fieldLabel="Zip/Postal Code"></app-error-msg>
            </div>
        </div>
        <hr />

        <div class="form-row">
            <div class="mb-3 col-md-8">
               
                <p-checkbox class="p-formcontrol"  name="billingInfo" label="Update Billing Information on Invoice/Receipt" id="billingInfo" inputId="binary" [binary]="true" value="{model.isInvoiceUpdate}"  [(ngModel)]="model.isInvoiceUpdate"  ></p-checkbox>
                 <sup><i class="fa fa-circle-info large ms-1" style="color: #004381;" 
                 pTooltip="If there are multiple short codes on this order, the Billing Information will be updated for all of them.
              If this was paid as part of a multi-invoice payment, that receipt will not be updated.
              If this short code was transferred as a pre-paid short code, there is no invoice or receipt to update. 
                   Refer to the Download Transfer Statement on the Short Code List for receipt of transfer." appendTo="body"
                        tooltipPosition="top" appendTo="body" tooltipStyleClass="toolCardData"></i></sup>
        </div>
        </div>
        <div class="footer">
            <div type="submit">
                <button id="save-button" class="btn btn-primary">Save</button>
                <button id="cancel-button" class="btn btn-secondary ms-3" (click)="cancel()">
                    Cancel
                </button>
            </div>
        </div>
    </form>
</ng-template>